var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 249,
    viewBox: "0 0 256 249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "-.007%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "0%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "73.613%",
    x2: "16.596%",
    y1: "86.406%",
    y2: "44.088%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "33.431%",
    x2: "70.239%",
    y1: "83.935%",
    y2: "44.739%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 132,
    cy: 239,
    fill: "#1B9DE8",
    fillRule: "nonzero",
    opacity: 0.1,
    rx: 40,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#535461",
    strokeWidth: 2,
    d: "M146.852 238.894s4.858-24.967 20.297-37.185c6.514-5.08 11.29-12.16 13.611-20.175a66.744 66.744 0 0 0 2.19-11.647"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    fillRule: "nonzero",
    d: "M192.606 159.349c-1.31 2.485-10.032 7.236-10.032 7.236s-1.103-9.66.196-12.148c.827-1.643 2.558-2.695 4.527-2.75 1.97-.056 3.87.894 4.971 2.482 1.101 1.589 1.23 3.57.338 5.18zM193.76 179.792c-2.57 1.463-12.717 1.072-12.717 1.072s4.764-8.897 7.327-10.347a5.41 5.41 0 0 1 5.378.02 5.369 5.369 0 0 1 2.696 4.637 5.302 5.302 0 0 1-2.683 4.615l-.001.003zM177.68 204.84c-2.967.02-11.47-5.47-11.47-5.47s8.714-5.608 11.68-5.624c2.85.139 5.038 2.56 4.982 5.514-.056 2.953-2.336 5.404-5.191 5.58zM165.557 221.106c-2.68.565-11.082-3.011-11.082-3.011s7.139-6.85 9.819-7.416c2.68-.564 5.135 1.312 5.484 4.191.349 2.88-1.541 5.672-4.221 6.236zM170.075 176.387c1.054 2.755 9.34 9.205 9.34 9.205s2.167-9.533 1.116-12.297c-1.056-2.755-4.253-4.295-7.14-3.441-2.888.854-4.372 3.779-3.316 6.533zM153.09 195.148c1.55 2.473 10.359 6.098 10.359 6.098s-.246-10.748-1.812-13.214c-.996-1.638-2.755-2.47-4.602-2.177-1.847.293-3.495 1.665-4.312 3.59-.818 1.925-.678 4.105.366 5.703zM141.743 216.9c1.25 2.537 9.459 7.628 9.459 7.628s.972-9.68-.281-12.218a5.084 5.084 0 0 0-4.26-2.907 5.134 5.134 0 0 0-4.63 2.318 5.182 5.182 0 0 0-.29 5.186l.002-.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M192.606 159.349c-1.31 2.485-10.032 7.236-10.032 7.236s-1.103-9.66.196-12.148c.827-1.643 2.558-2.695 4.527-2.75 1.97-.056 3.87.894 4.971 2.482 1.101 1.589 1.23 3.57.338 5.18zM193.76 179.792c-2.57 1.463-12.717 1.072-12.717 1.072s4.764-8.897 7.327-10.347a5.41 5.41 0 0 1 5.378.02 5.369 5.369 0 0 1 2.696 4.637 5.302 5.302 0 0 1-2.683 4.615l-.001.003zM177.68 204.84c-2.967.02-11.47-5.47-11.47-5.47s8.714-5.608 11.68-5.624c2.85.139 5.038 2.56 4.982 5.514-.056 2.953-2.336 5.404-5.191 5.58zM165.557 221.106c-2.68.565-11.082-3.011-11.082-3.011s7.139-6.85 9.819-7.416c2.68-.564 5.135 1.312 5.484 4.191.349 2.88-1.541 5.672-4.221 6.236zM170.075 176.387c1.054 2.755 9.34 9.205 9.34 9.205s2.167-9.533 1.116-12.297c-1.056-2.755-4.253-4.295-7.14-3.441-2.888.854-4.372 3.779-3.316 6.533zM153.09 195.148c1.55 2.473 10.359 6.098 10.359 6.098s-.246-10.748-1.812-13.214c-.996-1.638-2.755-2.47-4.602-2.177-1.847.293-3.495 1.665-4.312 3.59-.818 1.925-.678 4.105.366 5.703zM141.743 216.9c1.25 2.537 9.459 7.628 9.459 7.628s.972-9.68-.281-12.218a5.084 5.084 0 0 0-4.26-2.907 5.134 5.134 0 0 0-4.63 2.318 5.182 5.182 0 0 0-.29 5.186l.002-.006z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#535461",
    strokeWidth: 2,
    d: "M145.698 237.44s-5.637-24.944 3.945-42.592a39.497 39.497 0 0 0 4.591-24.174 65.476 65.476 0 0 0-2.703-11.605"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    fillRule: "nonzero",
    d: "M158.2 148.463c-.12 2.886-5.95 10.853-5.95 10.853s-5.16-8.764-5.032-11.654c.075-1.867 1.192-3.517 2.93-4.327 1.738-.81 3.834-.659 5.497.398 1.664 1.056 2.643 2.857 2.568 4.724l-.013.006zM165.856 165.882c-1.75 2.316-11.323 5.854-11.323 5.854s.583-9.897 2.324-12.22c1.752-2.317 5.184-2.77 7.666-1.014 2.482 1.757 3.074 5.06 1.323 7.377l.01.003zM164.003 194.24c-2.725 1.151-12.815-.388-12.815-.388s5.721-8.228 8.442-9.368c2.727-1.154 5.916.098 7.123 2.796a5.229 5.229 0 0 1-2.752 6.976l.002-.017zM158.203 215.726c-2.512 1.508-12.938 1.47-12.938 1.47s4.16-8.774 6.66-10.304c1.622-1.028 3.756-1.123 5.576-.246 1.819.876 3.038 2.585 3.186 4.466.147 1.881-.8 3.639-2.477 4.593l-.007.021zM143.996 170.306c1.761 2.1 10.587 4.471 10.587 4.471s-1.4-9.791-3.157-11.886c-1.14-1.359-2.901-1.907-4.62-1.439-1.72.469-3.137 1.882-3.716 3.708-.58 1.826-.234 3.788.906 5.146zM134.651 196.553c2.425 1.45 12.138.86 12.138.86s-4.35-9-6.777-10.447c-1.57-.993-3.564-.978-5.21.04-1.646 1.017-2.686 2.877-2.717 4.86-.032 1.982.95 3.776 2.566 4.687zM133.189 222.224c2.278 1.923 12.4 3.25 12.4 3.25s-3.113-9.92-5.393-11.858c-2.29-1.743-5.546-1.316-7.41.971-1.863 2.287-1.684 5.635.409 7.62l-.006.017z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M121 139h26v103h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF1",
    d: "M123 139h22v99h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M207.578 50H90.813c-4.014.103-7.97.986-11.647 2.601-11.87 5.272-18.778 13.547-20.729 31.899v42.397l-30.94-.328C21.275 126.569 19 136.373 19 143h209V71.749C228 59.738 218.869 50 207.578 50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M94 55h115.813C217.648 55 224 61.3 224 69.07V139H94V55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M92 55c17.12 0 31 13.95 31 31.16v37.59c0 8.422-6.792 15.25-15.171 15.25H76.17C67.792 139 61 132.172 61 123.75V86.16C61 68.95 74.88 55 92 55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M92 55c17.12 0 31 13.95 31 31.16v37.59c0 8.422-6.792 15.25-15.171 15.25H76.17C67.792 139 61 132.172 61 123.75V86.16C61 68.95 74.88 55 92 55z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M175 44h-26v43h11.802V63.276H175z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC80",
    d: "M173 43h-22v40h8.25V60.931H173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M67.224 65.005l26.614.016.026 43.513-26.614-.016z",
    transform: "rotate(-83.06 80.544 86.77)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF8E4",
    d: "M57.995 96.319l3.016-24.653 41.733 5.055-3.016 24.653z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B9DE8",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.32 77.829l-5.296-.654.477-3.977 5.296.654zM86.773 87.957L66.44 85.446l.154-1.29 20.334 2.512zM86.439 90.752l-14.826-1.831.103-.858 14.826 1.83z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M84.825 70.816l26.614.016.026 43.513-26.614-.016z",
    transform: "rotate(-83.06 98.145 92.58)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF8E4",
    d: "M75.596 102.133l3.016-24.653 41.733 5.055-3.016 24.653z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B9DE8",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.407 83.743l-5.221-.655.47-3.976 5.22.654zM103.596 93.87l-20.043-2.51.152-1.29 20.043 2.511zM103.26 96.666l-14.615-1.832.102-.858 14.614 1.831z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M49.795 71.189l36.075.021.035 58.98-36.075-.021z",
    transform: "rotate(-83.06 67.85 100.69)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M37.289 113.632l4.088-33.42 56.569 6.85-4.089 33.421z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B9DE8",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.478 89.133l-7.169-.85.646-5.164 7.169.85zM74.455 102.293L46.928 99.03l.21-1.675 27.526 3.263zM74.004 105.922l-20.072-2.38.14-1.117 20.072 2.379z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M73.655 79.065l36.075.022.035 58.98-36.075-.022z",
    transform: "rotate(-83.06 91.71 108.566)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M61.144 121.515l4.088-33.421 56.57 6.852-4.09 33.42z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B9DE8",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.126 98.035l-7.026-.85.633-5.164 7.026.85zM98.604 111.195l-26.977-3.262.205-1.676 26.977 3.263zM98.162 114.824l-19.671-2.38.137-1.117 19.67 2.379z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M91.146 55A32.25 32.25 0 0 0 79 57.362c1.5-.212 3.014-.318 4.53-.32 8.448 0 16.55 3.297 22.524 9.165 5.974 5.868 9.33 13.827 9.33 22.126V138H123V86.29C123 69.01 108.738 55 91.146 55z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M32.92 128H123v11H22c0-6.075 4.89-11 10.92-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.92 128H123v11H22c0-6.075 4.89-11 10.92-11z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M221.352 31.356L220 32l.155-.271-.119.036.169-.12L238.416 0l9.311 7.752 7.99 7.22-2.293 1.092L256 20.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M245.942 8L253 14.707 221 31l17.03-22.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M245.942 8L253 14.707 221 31l17.03-22.355z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M237.743 1L221 31l25-22.853zM253 20.942L221 31l26.748-19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M51.959 36.68L54 37l-.316-.303h.175l-.273-.095L16.493 1 7.49 15.38 0 28.498l3.468.545-1.538 7.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M8.957 17.524L2 29.651 53 38 20.152 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.957 17.524L2 29.651 53 38 20.152 15z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B9DE8",
    d: "M17.369 3L53 37 9 16.381zM4 36.076L53 37 7.258 21z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailImage);
export default __webpack_public_path__ + "static/media/mail-image.db077001.svg";
export { ForwardRef as ReactComponent };